import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ShipmentInspectionUpdateComponent } from '../shipment-inspection-update/shipment-inspection-update.component';
import { ToastrService } from 'ngx-toastr';
import { I18nModule } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';


@Component({
  selector: 'app-shipment-inspection-confirmation',
  imports: [CommonModule, NgbTooltipModule,I18nModule,SharedModule],
  templateUrl: './shipment-inspection-confirmation.component.html',
  styleUrls: ['./shipment-inspection-confirmation.component.scss']
})
export class ShipmentInspectionConfirmationComponent {
  @Input() updateInspectionData: any;
  @Input() formValues: any;
  @Input() activeTab: any;
  @Input() attachmentsList: any[] = [];
  @Input() filestoPushforcall: any[] = [];
  @Input() SaveObject: any;
  // @Input() validationAttempted: boolean = false;
  // @Input() validationFailed: boolean = false;
  // @Input() isValidated: boolean = false;
  @Input() inspectionCompleted: string = 'no';
  @Input() azureStatus: string = '';
  @Input() azureValidationRemark: any;
  enableLoader: boolean = false;


  constructor(
    public ActiveModal: NgbActiveModal,
    public modalService: NgbModal,
    private router: Router,
    private customProfileService: CustomProfileService,
    private toastrService: ToastrService
  ) { }

  formatDateWithSlash(dateValue: string): string {
    if (!dateValue) {
      return '';
    }

    return dateValue.replace(/-/g, '/');
  }
  
  goBack() {
    this.ActiveModal.dismiss('back');
    setTimeout(() => {
      const modalRef = this.modalService.open(ShipmentInspectionUpdateComponent, { centered: true, size: 'md' });
      modalRef.componentInstance.updateInspectionData = this.updateInspectionData;
      modalRef.componentInstance.activeTab = this.activeTab;
      modalRef.componentInstance.formValues = this.formValues;
      modalRef.componentInstance.attachmentsList = this.attachmentsList;
      modalRef.componentInstance.filestoPushforcall = this.filestoPushforcall;
      modalRef.componentInstance.azureStatus = this.azureStatus;
      modalRef.componentInstance.azureValidationRemark = this.azureValidationRemark;
      modalRef.componentInstance.inspectionCompleted = this.inspectionCompleted;
    }, 0);
  }

  confirmCompletion() {
    // SaveObject is passed from parent (onNextClick), use it
    
    const saveObj = this.SaveObject;
    // Always send stockAdjustmentRequested as true when confirming completion, as per commerce requirement, irrespective of the form value
    saveObj.stockAdjustmentRequested = true;
    console.log('Confirmation save object:', saveObj);
    this.callForSaving(saveObj);
  }


  private callForSaving(SaveObject: any) {
    this.enableLoader = true;

    // Upload attachments if there are new files
    if (this.filestoPushforcall.length > 0) {
      let attachmentdata = {
        nominationKey: this.updateInspectionData.nominationKey,
        nominationKeyItem: this.updateInspectionData.nominationItemNumber,
        files: this.filestoPushforcall
      };
      this.customProfileService.uploadInspdocument(this.updateInspectionData.nominationNumber, attachmentdata).subscribe(
        (res) => {
          if (res.success) {
            this.toastrService.show(res.success);
            this.customProfileService
              .saveShipmentInspectionUpdate(SaveObject, false)
              .subscribe(
                (response: any) => {
                  if (response) {
                    console.log('Save response:', response);
                    this.toastrService.show(
                      'Shipment inspection completed successfully',
                    );
                    this.customProfileService.setTemplateData('Completed');
                    this.enableLoader = false;
                    this.ActiveModal.close('confirmed');
                    // Navigate after closing modal
                    //this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                    // this.router.navigate(['/inventory/shipmentinspection']);
                    //});
                  } else {
                    this.toastrService.show(
                      'Response not returned from commerce, please contact support team',
                    );
                    this.enableLoader = false;
                  }
                },
                (err: any) => {
                  this.toastrService.show(
                    'Error while saving the data, please contact support team',
                  );
                  this.enableLoader = false;
                },
              );
          } else {
            this.enableLoader = false;
            this.toastrService.show(res.error);
          }
        },
        (err: any) => {
          this.enableLoader = false;
          this.toastrService.show("Sorry something went wrong, please try again!");
        }
      );
    }
    else{
      this.customProfileService
              .saveShipmentInspectionUpdate(SaveObject, false)
              .subscribe(
                (response: any) => {
                  if (response) {
                    console.log('Save response:', response);
                    this.toastrService.show(
                      'Shipment inspection completed successfully',
                    );
                    this.customProfileService.setTemplateData('Completed');
                    this.enableLoader = false;
                    this.ActiveModal.close('confirmed');
                  } else {
                    this.toastrService.show(
                      'Response not returned from commerce, please contact support team',
                    );
                    this.enableLoader = false;
                  }
                },
                (err: any) => {
                  this.toastrService.show(
                    'Error while saving the data, please contact support team',
                  );
                  this.enableLoader = false;
                },
              );
    }

    // Save the shipment inspection data
      
  }
}
